import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/shop/WholesaleGrid.tsx");
